import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import HostEarningsCalculator from './calculators/HostEarningsCalculator';
import ChargingCostEstimator from './calculators/ChargingCostEstimator';
import EVSavingsCalculator from './calculators/EVSavingsCalculator';

export default function CalculatorsPage() {
    return (
        <div className="bg-gray-50 min-h-screen py-16 px-4 sm:px-6 lg:px-8">
            <Helmet>
                <title>EV Charging Calculators | PeerChargeEV</title>
                <meta name="description" content="Calculate your EV charging costs, time, and potential earnings as a PeerChargeEV host using our free tools." />
            </Helmet>
            <div className="max-w-7xl mx-auto space-y-24">
                
                {/* Header */}
                <div className="text-center max-w-3xl mx-auto">
                    <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                        EV Calculators
                    </h1>
                    <p className="mt-4 text-xl text-gray-500">
                        Whether you want to earn money hosting a charger, save on your charging costs, or switch from a petrol vehicle, our tools give you instant answers.
                    </p>
                </div>

                {/* Calculators Sections */}
                <section id="host-earnings" className="scroll-mt-24">
                    <div className="mb-6 text-center lg:text-left">
                        <h2 className="text-2xl font-bold text-gray-900">1. Host Earnings Calculator</h2>
                        <p className="text-gray-600 mt-2">Find out how much passive income you can generate by sharing your home EV charger with the community.</p>
                    </div>
                    <HostEarningsCalculator />
                </section>

                <section id="charging-cost" className="scroll-mt-24">
                    <div className="mb-6 text-center lg:text-left">
                        <h2 className="text-2xl font-bold text-gray-900">2. Charging Cost Estimator</h2>
                        <p className="text-gray-600 mt-2">Estimate the cost and time required to charge your specific EV model, and see how much you save compared to public stations.</p>
                    </div>
                    <ChargingCostEstimator />
                </section>

                <section id="ev-savings" className="scroll-mt-24">
                    <div className="mb-6 text-center lg:text-left">
                        <h2 className="text-2xl font-bold text-gray-900">3. Petrol vs EV Savings</h2>
                        <p className="text-gray-600 mt-2">Thinking of buying an EV? Compare the running costs against your current petrol or diesel vehicle to see your long-term savings.</p>
                    </div>
                    <EVSavingsCalculator />
                </section>

            </div>
        </div>
    );
}
